import { Component, OnInit } from '@angular/core';
import { CtaService } from "../../_services/cta.service";

@Component({
  selector: 'bxl-blog',
  templateUrl: 'blog.component.html',
})
export class BlogComponent implements OnInit {
  initialized = false;
  constructor(public ctaService:CtaService,) { }

  ngOnInit(): void {
    this.loadScript()
    this.initialized = true;
  }

  public loadScript() {
    let body = <HTMLDivElement> document.body;
    let script = document.createElement('script');
    script.innerHTML = '';
    script.src = 'https://io.dropinblog.com/embedjs/14800db0-9512-45ad-b0b0-d66bcc625ff3.js';
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
}
